export const POI_TYPES = [
  'Attraction',
  'Monument/Landmark',
  'Park',
  'Station',
  'City Hall',
  'Airport',
  'Library',
  'Museum',
  'Art Gallery',
  'Square',
  'School/University',
  'Mall',
  'Stadium',
  'Popular area',
  'Church',
  'Harbor',
  'Theater',
];



// WEBPACK FOOTER //
// ./src/app/destinations/destination.constants.js